/** Convert Shopify GID or legacy id to numeric legacy string for API payloads. */
export function toNumericProductId(id: string): string {
  if (id.startsWith("gid://shopify/Product/")) {
    return id.split("/").pop() ?? id;
  }
  return id.replace(/^.*\//, "");
}

export function toNumericProductIds(ids: string[]): string[] {
  return [...new Set(ids.map(toNumericProductId).filter(Boolean))];
}

/** Convert numeric legacy id to Shopify GID for UI selection state. */
export function toGidProductId(id: string): string {
  if (id.startsWith("gid://")) return id;
  const numeric = toNumericProductId(id);
  return `gid://shopify/Product/${numeric}`;
}

export function toGidProductIds(ids: string[]): string[] {
  return ids.map(toGidProductId);
}
